import React from 'react';

class ToolTip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      widthSet: false,
    };
  }

  componentDidUpdate() {
    if (this.div && !this.state.widthSet) {
      this.setState({
        ...this.state,
        width: this.div.getBoundingClientRect().width,
        widthSet: true,
      });
    }
  }

  render() {
    let { show, id, onClick } = this.props;
    let item = document.querySelectorAll(`[data-mytip="${id}"]`)[0];
    if (!item) return null;
    let domRect = item.getBoundingClientRect();
    let x = domRect.left + Math.abs(domRect.left - domRect.right);
    let y = domRect.top + Math.abs(domRect.top - domRect.bottom);

    if (this.state.width) {
      x = x - this.state.width / 2;
    }

    return (
      show && (
        <div
          /*onClick={onClick}*/
          className="ot-tooltip"
          role="tooltip"
          aria-hidden="true"
          style={{ position: 'fixed', left: x, top: y }}
          ref={(item) => item && (this.div = item)}
        >
          {this.props.children}
        </div>
      )
    );
  }
}

export default ToolTip;
